"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSubjectIndirectSubjectsMultiple;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _createSubject = _interopRequireDefault(require("./createSubject"));

var _ensureIndirectSubjectId = _interopRequireDefault(require("./ensureIndirectSubjectId"));

function createSubjectIndirectSubjectsMultiple(_x, _x2, _x3) {
  return _createSubjectIndirectSubjectsMultiple.apply(this, arguments);
}

function _createSubjectIndirectSubjectsMultiple() {
  _createSubjectIndirectSubjectsMultiple = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(ctx, rule, subjects) {
    var newSubjects;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            newSubjects = (subjects || []).filter(function (_ref) {
              var product = _ref.product;
              return product && (typeof product === 'string' || (0, _typeof2.default)(product) === 'object');
            });

            if (!newSubjects.length) {
              _context2.next = 8;
              break;
            }

            _context2.next = 4;
            return Promise.all(newSubjects.map( /*#__PURE__*/function () {
              var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_ref2) {
                var fixedPrice, price, product, quantity;
                return _regenerator.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        fixedPrice = _ref2.fixedPrice, price = _ref2.price, product = _ref2.product, quantity = _ref2.quantity;
                        _context.t0 = _ensureIndirectSubjectId.default;
                        _context.t1 = rule;
                        _context.next = 5;
                        return (0, _createSubject.default)(ctx, {
                          product: product,
                          price: price,
                          quantity: quantity,
                          fixedPrice: fixedPrice
                        });

                      case 5:
                        _context.t2 = _context.sent;
                        return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2));

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x4) {
                return _ref3.apply(this, arguments);
              };
            }()));

          case 4:
            _context2.t1 = _context2.sent;
            _context2.t0 = {
              indirectSubjects: _context2.t1
            };
            _context2.next = 9;
            break;

          case 8:
            _context2.t0 = {};

          case 9:
            return _context2.abrupt("return", _context2.t0);

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createSubjectIndirectSubjectsMultiple.apply(this, arguments);
}